export class Pattern {
    public static helTal = "^(-)?[0-9]+$"; // Heltal, både negative og positive
    public static positivHelTal = "^[0-9]+$"; // Heltal, kun positive
    public static kommaTal = "^(-)?[0-9]+([.,][0-9]+)?$"; // Kommatal, både negative og positive
    public static positivKommaTal = "^[0-9]+([.,][0-9]+)?$"; // Kommatal, kun positive
    public static postNr = "^[0-9]{4,4}$"; // Kun fire heltal er gyldigt
    public static registreringsNr = "^[0-9]{4,4}$"; // Kun fire heltal er gyldigt
    public static kontoNr = "^[0-9]{10,10}$"; // Kun ti heltal er gyldigt
}
